import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { environment } from '../../../../environments/environment';
import { TranslateService } from "@ngx-translate/core";
import { CustomerService } from "../../services/customer.service";
import { FileUploadConstants } from "../../constants/file-upload.constants";
import { ReportService } from "../../services/report.service";
import { CommonService } from "../../../shared/services/common.service";
import { NotificationType } from "../../enums/notification-types.enum";
import { DistributorIdFormatPipe } from "../../../common/pipes/distributor-id-format.pipe";
import { StoreConfig } from "../../../shared/interface/StoreConfig.interface";
import { CurrencyTransformPipe } from "../../../common/pipes/currency-format.pipe";
import { moment } from "ngx-bootstrap/chronos/test/chain";
import { Subscription } from 'rxjs';
import { ResponseStatus } from "../../constants/response-status-constants";
import { CacheService } from "../../../shared/services/cache.service";
import { CacheKey } from "../../../shared/constants/cachekey.constants";
import { DatePipe } from '@angular/common'
import { PaginationInstance } from "ngx-pagination";
import { Utils } from "../../../shared/Utils/utils";
import { DateConstants } from "../../constants/date.constants";

@Component({
  selector: 'app-iban-reports',
  templateUrl: '../../templates/template1/views/reports/iban-reports.component.html',
  styleUrls: [
    '../../templates/template1/themes/default/less/iban-reports.less'
  ],
  providers: [DistributorIdFormatPipe, CurrencyTransformPipe]
})

export class IBANReportsComponent implements OnInit {

  @Input() fromDate: string;
  @Input() toDate: string;
  @Input() storeId: [number];
  @Output() isLoadedData = new EventEmitter<boolean>();
  @Output() addFavoriteEvent = new EventEmitter<boolean>();
  @Input() storeInfo: StoreConfig;
  @Input() countryName: string
  pageSizes = [50, 100, 150, 200];
  pageNumber: number = 1;
  pageSize: number = 50;
  pageCount: number = 0;
  currentDate = new Date();
  excelIconUrl = environment.cdnURL + '/flpi/images/ms_excel.ico';
  printIconUrl = environment.cdnURL + '/flpi/images/print_icon.png';
  IBANReports = null;
  allIBANReport = null;
  isResponseError = false;
  isLoading = false;
  isAllIBANReportLoading = false;
  isShowReport = true;
  csvType = FileUploadConstants.CSV_FILE_EXTENSION;
  printType = FileUploadConstants.PRINT;
  request: Subscription;
  dashboardReports = null;
  pollCount: number = 0;
  maxPollCount = 15;

  public paginationInstance: PaginationInstance = {
    id: 'IBAN-reports-pagination',
    itemsPerPage: 10,
    currentPage: 1
};

  constructor(
    private _translateService: TranslateService,
    private _customerservice: CustomerService,
    private _reportService: ReportService,
    private _commonService: CommonService,
    private _cacheService: CacheService,
    private _datePipe: DatePipe,

  ) { }

  ngOnInit(): void {
    this.getIBANDashboardReport();
  }

  getIBANDashboardReport(): void {
    this.isLoading = true;
    this.getIBANDashBoardsReport(this._reportService.getConstructedIBANDashBoardUrl(
      this.storeId, this.fromDate, this.toDate, this.pageNumber, this.pageSize, false));

  }

  getIBANDashBoardsReport(url: string) {
    this.request = this._reportService
      .getIBANDashBoardPollReport(url)
      .subscribe(res => {
        if (res.status === ResponseStatus.COMPLETED) {
          this.reportIBANDashBoardSuccess(res.responseModel);
        } else {
          this.reportIBANDashBoardPending(res);
        }
      },
        (error) => {
          if (
            error.status == 504 ||
            (error.name && error.name.toLowerCase() == "typeerror")
          ) {
            const message: any = this._translateService.get(
              "reports.Sorry It seems like you selected wider date range Please select the minimum date range and try again"
            );
            this._commonService.createNotification(
              "",
              message.value,
              NotificationType.ERROR
            );
            this.setDefaultValues();
          } else {
            const message: any = this._translateService.get(
              "reports.Something Went Wrong, Please try again after some time"
            );
            this._commonService.createNotification(
              "",
              message.value,
              NotificationType.ERROR
            );
            this.setDefaultValues();
          }
        });
  }


  reportIBANDashBoardSuccess(response: any) {
    if (response && response.content) {
      response.content.forEach((element) => {
        if (element.createdDate) {
          element.createdDate = this.getUtcDate(element.createdDate);
        }
        if (element.birthdate) {
          element.birthdate = (element.birthdate.slice(0, element.birthdate.indexOf('T')));
        }
        if (element.creditAssessmentEnabled == 1) {
          element.creditAssessmentEnabled = 'Yes';
        }else{
          element.creditAssessmentEnabled = 'NO';
        }
      });
      this.IBANReports = response.content;      this.isLoading = false;
      this.isResponseError = false;
      this.pageCount = response.totalCount;
      this.isLoadedData.emit(true);
      this.exportFile('csv');
    } else if (
      response &&
      response.status &&
      response.status.code === 504
    ) {
      const message: any = this._translateService.get(
        "reports.Sorry It seems like you selected wider date range Please select the minimum date range and try again"
      );
      this._commonService.createNotification(
        "",
        message.value,
        NotificationType.ERROR
      );
      this.setDefaultValues();
    } else {
      this.setDefaultValues();
    }

  }

  reportIBANDashBoardPending(res: any) {
    if ((res.status === ResponseStatus.IN_PROGRESS) || (res.status === ResponseStatus.QUEUED)) {
      if (this.pollCount < this.maxPollCount) {
        this.pollCount = this.pollCount + 1;
        this.getIBANDashBoardsReport(res.location);
      }
    } else {
      this._cacheService.remove(CacheKey.pollCount);
    }
    this._cacheService.remove(CacheKey.pollCount);
  }



  /**
      * To get iban reports
      * @returns void
      */

  /**
       * To Set Default Values
       */
  setDefaultValues(): void {
    this.isLoading = false;
    this.isResponseError = true;
    this.pageCount = 0;
    this.isLoadedData.emit(true);
  }

  /**
       * To load orders report
       * @returns void
       */
  loadOrdersReports(): void {
    this.isShowReport = true;
    this.getIBANDashboardReport();
  }

  /**
  * To change page size
  * @param  {number} pageSize
  * @returns void
  */
  pageSizeChange(pageSize: number): void {
    if (pageSize) {
      this.pageNumber = 1;
      this.pageSize = pageSize;
      this.getIBANDashboardReport();
    }
  }

  /**
   * To change page number
   * @param  {number} pageNumber
   */
  pageChange(pageNumber: number) {
    this.pageNumber = pageNumber;
    this.pollCount = 0;
    this.getIBANDashboardReport();
  }

  /**
       * To emit add favorite event to parent component
       * @returns void
       */
  addToFavorite(): void {
    this.addFavoriteEvent.emit(true);
  }

  getUtcDate(timeStamp: any): string {
    if (typeof (timeStamp) == 'number') {
      timeStamp = moment.utc(timeStamp).toISOString();
    }
    if (typeof (timeStamp) == 'string') {
      if (timeStamp && timeStamp.indexOf('T') > -1 && timeStamp.indexOf('.') > -1) {
        timeStamp = timeStamp.split('.')[0];
      }
    }
    timeStamp = timeStamp.replace('T', ' ');
    return timeStamp;
  }

  /**
       * To Export The file
       */
  exportFile(type): void {
    if (this.allIBANReport && this.allIBANReport.length > 0) {
      this.download(type);
    } else {
      this.fetchAllIBANReport(type);
    }
  }

  /**
       * To Fetch all orders report data from service
       */
  fetchAllIBANReport(type): void {
    this.isAllIBANReportLoading = true;
    this._reportService.getIBANReport(this.storeId, this.fromDate, this.toDate, this.pageNumber, this.pageSize, true).subscribe(response => {
      if (response) {
        this.isAllIBANReportLoading = false;
        response.content.forEach((element) => {
          if (element.createdDate) {
            element.createdDate = this.getUtcDate(element.createdDate);
          }
          if (element.birthdate) {
            element.birthdate = (element.birthdate.slice(0, element.birthdate.indexOf('T')));
          }
          if (element.creditAssessmentEnabled == 1) {
            element.creditAssessmentEnabled = 'Yes';
          }else{
            element.creditAssessmentEnabled = 'NO'; 
          }
        });
        this.allIBANReport = response.content;
        this.download(type);
      } else {
        this.isAllIBANReportLoading = false;
        this.allIBANReport = null;
      }
    }, (error) => {
      const message: any = this._translateService.get('reports.Something Went Wrong, Please try again after some time');
      this._commonService.createNotification('', message.value, NotificationType.ERROR);
      this.allIBANReport = null;
      this.isAllIBANReportLoading = false;
    });
  }


  /**
       * To download CSV or Print file from response data
       * @param  {string} type
       * @returns void
       */
  download(type: string): void {
    const allIBANReportLength = this.allIBANReport && this.allIBANReport.length ?
      this.allIBANReport && this.allIBANReport.length : null;
    if (allIBANReportLength > 0) {
      const columns = [
        this._translateService.get('IBAN-reports.Country/Store')['value'],
        this._translateService.get('IBAN-reports.FBO ID')['value'],
        this._translateService.get('IBAN-reports.Name')['value'],
        this._translateService.get('IBAN-reports.Address')['value'],
        this._translateService.get('IBAN-reports.Birthdate')['value'],
        this._translateService.get('IBAN-reports.IBAN')['value'],
        this._translateService.get('IBAN-reports.Authorized Date')['value'],
        this._translateService.get('IBAN-reports.Credit Assessment Completed')['value'],
      ];
      const title = this._translateService.get('IBAN_Reports')['value'] + "_" + this.fromDate + this._translateService.get('reports._To_')['value'] + this.toDate;
      if (type === this.csvType) {
        this.downloadCSV(columns, allIBANReportLength);
      } else if (type === this.printType) {
        this.printReportDetails(title, columns, allIBANReportLength);
      }
    }
  }


  /**
       * CSV file download functionality
       */
  downloadCSV(columns: any, allIBANReportLength: any) {
    let rowdata = new Array<any>();
    const finalrows = new Array<any>();
    for (let i = 0; i < allIBANReportLength; i++) {
      rowdata = [];
      const row = this.allIBANReport[i];
      const name= row.firstName +""+ row.lastName ;
      const address=row.addressLine1 +"," + row.city +","+ row.postalCode;
      rowdata.push(row.country ? row.country : '');
      rowdata.push(row.distributorID ? (String.fromCharCode(39) + row.distributorID) : '');
      rowdata.push(  name? (String.fromCharCode(39) + name) : '');
      rowdata.push(address ? (String.fromCharCode(39) + address) : '');
      rowdata.push(row.birthdate ? (String.fromCharCode(39) + row.birthdate) : '');
      rowdata.push(row.iban ? row.iban : '');
      rowdata.push(row.createdDate ? (String.fromCharCode(39) + row.createdDate) : '');
      rowdata.push(row.creditAssessmentEnabled ? (String.fromCharCode(39) + row.creditAssessmentEnabled) : '');
      finalrows.push(rowdata);
    }
    this._customerservice.ExcelDownload(columns, finalrows, 'IBAN_Reports', '', false);


  }

  /**
      * Print functionality for report details printing
      */
  printReportDetails(title: string, columns: any, allIBANReportLength: any) {
    let rowdataForPrint = new Array<any>();
    const finalrowsForPrint = new Array<any>();
    for (let i = 0; i < allIBANReportLength; i++) {
      rowdataForPrint = [];
      const rowForPrint = this.allIBANReport[i];
      const name= rowForPrint.firstName +""+ rowForPrint.lastName ;
      const address=rowForPrint.addressLine1 +"," + rowForPrint.city +","+ rowForPrint.postalCode;
      rowdataForPrint.push(rowForPrint.country ? rowForPrint.country : '');
      rowdataForPrint.push(rowForPrint.distributorID ? (String.fromCharCode(39) + rowForPrint.distributorID) : '');
      rowdataForPrint.push(name ? (String.fromCharCode(39) + name) : '');
      rowdataForPrint.push(address ? (String.fromCharCode(39) + address) : '');
      rowdataForPrint.push(rowForPrint.birthdate ? (String.fromCharCode(39) + rowForPrint.birthdate) : '');
      rowdataForPrint.push(rowForPrint.iban ? rowForPrint.iban : '');
      rowdataForPrint.push(rowForPrint.createdDate ? (String.fromCharCode(39) + rowForPrint.createdDate) : '');
      rowdataForPrint.push(rowForPrint.creditAssessmentEnabled ? (String.fromCharCode(39) + rowForPrint.creditAssessmentEnabled) : '');
      finalrowsForPrint.push(rowdataForPrint);
    }
    this._customerservice.constructTableAndPrint(columns, finalrowsForPrint, title);
  }



}


// WEBPACK FOOTER //
// ./src/app/customerservice/components/reports/iban-report.component.ts